module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/Flowing.ab2efa90.png";